export const skeletonModuleOverview = [
  {
    id: "anatomy",
    title: "Skeleton Anatomy",
    description: "Learn the structure of the skeleton",
    icon: "❤️",
    customImage: "module-skeleton-anatomy.png",
    gradient: "from-gray-200 via-yellow-50 to-rose-200 border-gray-600",
  },
  {
    id: "histology",
    title: "Skeleton Histology",
    description: "Microscopic structure of the skeleton",
    icon: "🔬",
    customImage: "module-skeleton-anatomy.png",
    gradient: "from-gray-300 via-yellow-50 to-yellow-100 border-gray-600",
  },
  {
    id: "physiology",
    title: "Skeletal Physiology",
    description: "Bone remodeling and mineral storage",
    icon: "⚡",
    gradient: "from-gray-200 via-yellow-50 to-rose-200 border-gray-600",
  },
];
